export class SnackMessage {

  constructor(public type: string,
              public message: string) {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/snack-messages/snack-message.model.ts